import { createFileRoute } from '@tanstack/react-router';

interface EntityTemplateAddSearch {
  id?: string;
}

export const Route = createFileRoute('/w/entity-templates/add')({
  staticData: { hideShell: true },
  validateSearch: (search: Record<string, unknown>): EntityTemplateAddSearch => ({
    id: typeof search.id === 'string' ? search.id : undefined,
  }),
});
